import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import DashboardTemplate from "../../Common/DashboardTemplate";
import {Checkbox, CircularProgress, TablePagination} from "@material-ui/core";
import axios from 'axios';
import {ServiceLocator} from "../../../Services/ServiceLocator";
import TextField from "@material-ui/core/TextField";
import DrawerMenuRight from "../../Common/DrawerMenuRight";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {Button} from "@material-ui/core";
import { v4 as uuid } from 'uuid';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import PrintIcon from '@material-ui/icons/Print';
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import {getNumberInputDisplayValue, parseNumberInputValue} from '../../../utils/numberInputUtils';
import PartDisplay from '../../Common/PartDisplay';
import PartAutocompleteOption from '../../Common/PartAutocompleteOption';
import { isImpliedPartRelation } from '../../../utils/bomContributions';

import { AuthenticationService } from "../../../Services/AuthenticationService";
import { filterPersistenceService } from "../../../Services/FilterPersistenceService";
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import dayjs from 'dayjs';
import { fromUtcForDisplay, formatUtcForDisplay, dateTimePickerToUtc, toUtcForStorage } from '../../../utils/dateUtils';
let adminUsers = [];
let assemblies = [];
let subAssemblies = [];
let packageLogs = [];
let assemblyFamilies = [];

const styles = theme => ({
    wrapper: {
        margin: -5,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    toolbarLeft: {
        display: 'flex',
        alignItems: 'center',
    },
    toolbarRight: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    filterToggle: {
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: '2px 10px',
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        minWidth: '150px',
        '& .MuiCheckbox-root': {
            padding: '0px',
            color: '#35d2d9',
            '&.Mui-checked': {
                color: '#35d2d9',
            },
        }
    },
    filterLabel: {
        marginLeft: '8px',
        fontSize: '14px',
        color: 'rgba(0, 0, 0, 0.87)',
    },
});

// Helper functions for determining currently selling assembly
const getCurrentlySellingAssemblyId = (assemblyId, assemblies) => {
    // Get all assemblies with the same assemblyId that don't have a finalOrderNumber
    const assembliesWithoutFinalOrder = assemblies.filter(assembly => 
        assembly.assembly && assembly.assembly.assemblyId === assemblyId && 
        !assembly.assembly.finalOrderNumber
    );
    
    // If only one assembly without finalOrderNumber, it's the currently selling one
    if (assembliesWithoutFinalOrder.length === 1) {
        return assembliesWithoutFinalOrder[0].assembly.id;
    }
    
    // If multiple assemblies without finalOrderNumber, find the one with the lowest revision
    if (assembliesWithoutFinalOrder.length > 1) {
        // Sort by revision (ascending) and return the lowest
        const sortedAssemblies = assembliesWithoutFinalOrder.sort((a, b) => {
            const revisionA = a.assembly.revision || '';
            const revisionB = b.assembly.revision || '';
            return revisionA.localeCompare(revisionB, undefined, { numeric: true, sensitivity: 'base' });
        });
        return sortedAssemblies[0].assembly.id;
    }
    
    // If no assemblies without finalOrderNumber, return null
    return null;
};

const isAssemblyCurrentlySelling = (assembly, assemblies) => {
    if (!assembly || assembly.finalOrderNumber) {
        return false;
    }
    
    const currentlySellingId = getCurrentlySellingAssemblyId(assembly.assemblyId, assemblies);
    return currentlySellingId === assembly.id;
};

class Packaging extends React.Component {
    state = {
        loading: true,
        user: {},
        users: [],
        orders: [],
        reloads: [],
        transactions: [],
        calculatorUnpacked: 0,
        page: 0,
        rowsPerPage: 100,
        rebalanceInventory: true,
        logsPage: 0,
        logsRowsPerPage: 100,
        logsSearchTerm: '',
        logsSortBy: 'logDate',
        logsSortOrder: 'desc',
        editingLog: null,
        editingLogOpen: false,
        savingEditLog: false,
        addingLogOpen: false,
        savingLog: false,
        addLogEntries: [],
        newLogReason: '',
        newLogDate: new Date(),
        newLogDateManuallyChanged: false,
        editLogAssembly: null,
        editLogType: '',
        editLogQuantity: 0,
        editLogReason: '',
        editLogDate: new Date(),
        showOldRevs: false,
        showDeactivated: false,
        showCurrentlyPackaging: true
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage}, () => {
            this.saveFilterSettings();
        });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        }, () => {
            this.saveFilterSettings();
        });
    };

    constructor(props) {
        super(props);
        globalProps = props;

        const jwtToken = AuthenticationService.getInstance().getToken();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    }

    componentDidMount() {
        this.loadSavedFilterSettings();
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        // Handle URL changes to maintain logs view state
        if (prevProps.location?.pathname !== this.props.location?.pathname) {
            const shouldShowLogs = this.props.location?.pathname?.includes('logs') || false;
            if (this.state.showingLogs !== shouldShowLogs) {
                this.setState({ showingLogs: shouldShowLogs });
            }
        }
    }
    loadSavedFilterSettings = () => {
        const savedSettings = filterPersistenceService.loadFilterSettings('packaging');
        if (savedSettings) {
            this.setState({
                page: savedSettings.page || 0,
                rowsPerPage: savedSettings.rowsPerPage || 100,
                searchTerm: savedSettings.searchTerm || '',
                showAdvancedInfo: savedSettings.showAdvancedInfo || false,
                showDeactivated: savedSettings.showDeactivated || false,
                showOldRevs: savedSettings.showOldRevs || false,
                showCurrentlyPackaging: savedSettings.showCurrentlyPackaging !== undefined ? savedSettings.showCurrentlyPackaging : true
            });
        }
    }

    saveFilterSettings = () => {
        const settings = {
            page: this.state.page,
            rowsPerPage: this.state.rowsPerPage,
            searchTerm: this.state.searchTerm,
            showAdvancedInfo: this.state.showAdvancedInfo,
            showDeactivated: this.state.showDeactivated,
            showOldRevs: this.state.showOldRevs,
            showCurrentlyPackaging: this.state.showCurrentlyPackaging
        };
        filterPersistenceService.saveFilterSettings('packaging', settings);
    }

    loadData = () => {
        const self = this;
        const user = AuthenticationService.getInstance().getUser();
        if (!user || !user.userPermissions || !user.userPermissions.includes('Workshop')) {
            globalProps.history.push('/login');
            return;
        }

        self.setState({loading: true});
        Promise.all([self.loadAdminUsers(), self.loadAssemblies(), self.loadSubAssemblies(), self.loadParts(), self.loadPackageLogs(), self.loadAssemblyFamilies()]).then(() => {
            // Preserve current search term and reapply search filter
            const currentSearchTerm = this.state.searchTerm;
            let assembliesAndSubAssemblies = assemblies.concat(subAssemblies);
            
            // Apply filters
            assembliesAndSubAssemblies = assembliesAndSubAssemblies.filter(x => {
                const assembly = x.assembly;
                const subAssembly = x.subAssembly;
                
                // Skip if neither assembly nor subAssembly exists
                if (!assembly && !subAssembly) return false;
                
                // Filter by active status
                if (assembly && !this.state.showDeactivated && !assembly.isActive) return false;
                if (subAssembly && !this.state.showDeactivated && !subAssembly.isActive) return false;
                
                // Filter by revision (only show current revisions unless showOldRevs is true)
                if (assembly && !this.state.showOldRevs && assembly.finalOrderNumber) return false;
                if (subAssembly && !this.state.showOldRevs && subAssembly.finalOrderNumber) return false;
                
                // Filter by currently packaging (only show isCurrentlyPackaging=true unless showCurrentlyPackaging is false)
                // Temporarily disabled to debug - check if isCurrentlyPackaging property exists
                // if (assembly && this.state.showCurrentlyPackaging && assembly.hasOwnProperty('isCurrentlyPackaging') && !assembly.isCurrentlyPackaging) return false;
                // if (subAssembly && this.state.showCurrentlyPackaging && subAssembly.hasOwnProperty('isCurrentlyPackaging') && !subAssembly.isCurrentlyPackaging) return false;
                
                return true;
            });
            
            // If there's a current search term, reapply the search filter
            if (currentSearchTerm) {
                const searchTerms = currentSearchTerm.toLowerCase().split(' ').filter(term => term.length > 0);
                if (searchTerms.length > 0) {
                    assembliesAndSubAssemblies = assembliesAndSubAssemblies.filter(x => {
                        const assembly = x.assembly;
                        const subAssembly = x.subAssembly;
                        
                        // All search terms must match at least one field
                        return searchTerms.every(term => {
                            const searchTerm = term.toLowerCase();
                            if (assembly) {
                                return (assembly.assemblyId && assembly.assemblyId.toLowerCase().includes(searchTerm)) ||
                                       (assembly.description && assembly.description.toLowerCase().includes(searchTerm));
                            }
                            if (subAssembly) {
                                return (subAssembly.subAssemblyId && subAssembly.subAssemblyId.toLowerCase().includes(searchTerm)) ||
                                       (subAssembly.description && subAssembly.description.toLowerCase().includes(searchTerm));
                            }
                            return false;
                        });
                    });
                }
            }
            
            // Preserve showingLogs state if already true, otherwise check URL
            const shouldShowLogs = self.state.showingLogs || globalProps.location.pathname.includes('logs');
            self.setState({
                showingLogs: shouldShowLogs,
                assemblies,
                subAssemblies,
                assembliesAndSubAssemblies,
                loading: false,
                user,
                adminUsers,
                packageLogs,
                permissions: user.userPermissions
            });
            // Focus search bar after render
            setTimeout(() => {
                if (this.searchInputRef) {
                    this.searchInputRef.focus();
                }
            }, 100);
        });
    };

    loadAdminUsers = () => {
        const userService = ServiceLocator.Instance.getUserService();
        return userService.getAdminUsers().then((adminUsersResult) => {
            adminUsers = adminUsersResult;
        });
    };

    loadAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllAssembliesExpanded().then((assembliesResult) => {
            assembliesResult.forEach((assembly) => {
                assembly.quantityOnShelf = assembly.totalAssembledOnHandWithRev;
                assembly.minAhead = 2;
                assembly.tgtAhead = 10
            });
            assemblies = assembliesResult.sort(function (a, b) {
                if (a.assembly.assemblyId > b.assembly.assemblyId) return 1;
                if (b.assembly.assemblyId > a.assembly.assemblyId) return -1;
                return 0;
            });
        });
    };

    loadSubAssemblies = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAllSubAssembliesExpanded().then((subAssembliesResult) => {
            subAssembliesResult.forEach((assembly) => {
                assembly.minAhead = 2;
                assembly.tgtAhead = 10
            });
            subAssemblies = subAssembliesResult.sort(function (a, b) {
                if (a.subAssembly.subAssemblyId > b.subAssembly.subAssemblyId) return 1;
                if (b.subAssembly.subAssemblyId > a.subAssembly.subAssemblyId) return -1;
                return 0;
            });
        });
    };

    loadParts = () => {
        const self = this;
        self.setState({loading: true});
        const partService = ServiceLocator.Instance.getPartService();

        return partService.getAllPartsExpanded().then((parts) => {
            parts = parts.sort(function (a, b) {
                if (a.part.partId < b.part.partId) return -1;
                if (a.part.partId > b.part.partId) return 1;
                return 0;
            });
            self.setState({parts});
        });
    };

    loadPackageLogs = () => {
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getPackageLogs().then((packageLogsResult) => {
            packageLogs = packageLogsResult.sort(function (a, b) {
                return new Date(b.logDate) - new Date(a.logDate);
            });
        });
    };

    loadAssemblyFamilies = () => {
        const self = this;
        const assemblyService = ServiceLocator.Instance.getAssemblyService();

        return assemblyService.getAssemblyFamilies().then((assemblyFamiliesResult) => {
            assemblyFamilies = assemblyFamiliesResult;
            self.setState({assemblyFamilies});
        });
    };

    editAssembly = (assembly, subAssembly, newTab) => {
        if (newTab)
            window.open(`/admin/assemblies/${assembly ? assembly.assembly.id : subAssembly.subAssembly.id}`);
        else
            globalProps.history.push(`/admin/assemblies/${assembly ? assembly.assembly.id : subAssembly.subAssembly.id}`)
    };

    searchAssembly = (event) => {
        const searchInput = event.target.value;
        this.setState({searchTerm: event.target.value, page: 0}, () => {
            this.saveFilterSettings();
            // Use reapplyFilters to ensure all filters are applied consistently
            this.reapplyFilters();
        });
    };

    searchLogs = (event) => {
        const searchTerm = event.target.value;
        this.setState({logsSearchTerm: searchTerm, logsPage: 0});
    };

    reapplyFilters = () => {
        const {assemblies, subAssemblies, searchTerm} = this.state;
        let assembliesAndSubAssemblies = assemblies.concat(subAssemblies);
        
        // Apply filters
        assembliesAndSubAssemblies = assembliesAndSubAssemblies.filter(x => {
            const assembly = x.assembly;
            const subAssembly = x.subAssembly;
            
            // Skip if neither assembly nor subAssembly exists
            if (!assembly && !subAssembly) return false;
            
            // Filter by active status
            if (assembly && !this.state.showDeactivated && !assembly.isActive) return false;
            if (subAssembly && !this.state.showDeactivated && !subAssembly.isActive) return false;
            
            // Filter by revision (only show current revisions unless showOldRevs is true)
            if (assembly && !this.state.showOldRevs && assembly.finalOrderNumber) return false;
            if (subAssembly && !this.state.showOldRevs && subAssembly.finalOrderNumber) return false;
            
            // Filter by currently packaging (only show isCurrentlyPackaging=true unless showCurrentlyPackaging is false)
            // Temporarily disabled to debug - check if isCurrentlyPackaging property exists
            // if (assembly && this.state.showCurrentlyPackaging && assembly.hasOwnProperty('isCurrentlyPackaging') && !assembly.isCurrentlyPackaging) return false;
            // if (subAssembly && this.state.showCurrentlyPackaging && subAssembly.hasOwnProperty('isCurrentlyPackaging') && !subAssembly.isCurrentlyPackaging) return false;
            
            return true;
        });
        
        // Apply search filter if there's a search term
        if (searchTerm) {
            const searchTerms = searchTerm.toLowerCase().split(' ').filter(term => term.length > 0);
            if (searchTerms.length > 0) {
                assembliesAndSubAssemblies = assembliesAndSubAssemblies.filter(x => {
                    const assembly = x.assembly;
                    const subAssembly = x.subAssembly;
                    
                    // All search terms must match at least one field
                    return searchTerms.every(term => {
                        const searchTerm = term.toLowerCase();
                        if (assembly) {
                            return (assembly.assemblyId && assembly.assemblyId.toLowerCase().includes(searchTerm)) ||
                                   (assembly.description && assembly.description.toLowerCase().includes(searchTerm));
                        }
                        if (subAssembly) {
                            return (subAssembly.subAssemblyId && subAssembly.subAssemblyId.toLowerCase().includes(searchTerm)) ||
                                   (subAssembly.description && subAssembly.description.toLowerCase().includes(searchTerm));
                        }
                        return false;
                    });
                });
            }
        }
        
        this.setState({assembliesAndSubAssemblies, page: 0});
    };

    toggleOldRevs = () => {
        const {showOldRevs} = this.state;
        this.setState({showOldRevs: !showOldRevs}, () => {
            this.saveFilterSettings();
            this.reapplyFilters();
        });
    };

    toggleDeactivated = () => {
        const {showDeactivated} = this.state;
        this.setState({showDeactivated: !showDeactivated}, () => {
            this.saveFilterSettings();
            this.reapplyFilters();
        });
    };

    toggleCurrentlyPackaging = () => {
        const {showCurrentlyPackaging} = this.state;
        this.setState({showCurrentlyPackaging: !showCurrentlyPackaging}, () => {
            this.saveFilterSettings();
            this.reapplyFilters();
        });
    };

    handleLogsChangePage = (event, newPage) => {
        this.setState({logsPage: newPage});
    };

    handleLogsChangeRowsPerPage = (event) => {
        this.setState({logsRowsPerPage: parseInt(event.target.value, 10)});
        this.setState({logsPage: 0});
    };

    changeNewLogReason = (event) => {
        this.setState({newLogReason: event.target.value});
    };

    openAddLog = () => {
        this.setState({
            addingLogOpen: true,
            savingLog: false,
            addLogEntries: [{ id: uuid(), assembly: null, quantity: 1 }],
            newLogReason: '',
            newLogDate: new Date(),
            newLogDateManuallyChanged: false
        });
    };

    handleCloseNewLog = () => {
        this.setState({
            addingLogOpen: false,
            addLogEntries: [{ id: uuid(), assembly: null, quantity: 1 }],
            newLogReason: '',
            newLogDate: new Date(),
            newLogDateManuallyChanged: false
        });
    };

    handleAddLogAssemblyChange = (index, newValue) => {
        const entries = [...this.state.addLogEntries];
        entries[index].assembly = newValue;
        if (index === entries.length - 1 && newValue) {
            entries.push({ id: uuid(), assembly: null, quantity: 1 });
        }
        this.setState({ addLogEntries: entries }, () => {
            if (newValue) {
                setTimeout(() => {
                    const quantityField = document.querySelector(`input[type="number"][data-entry-index="${index}"]`);
                    if (quantityField) {
                        quantityField.focus();
                        quantityField.select();
                    }
                }, 100);
            }
        });
    };

    handleAddLogQuantityChange = (index, event) => {
        const entries = [...this.state.addLogEntries];
        entries[index].quantity = event.target.value;
        this.setState({ addLogEntries: entries });
    };

    handleAddLogQuantityKeyDown = (index, event) => {
        if ((event.key === 'Tab' || event.key === 'Enter') && !event.shiftKey) {
            event.stopPropagation();
            event.preventDefault();
            if (index === this.state.addLogEntries.length - 1 && this.state.addLogEntries[index].assembly) {
                const entries = [...this.state.addLogEntries, { id: uuid(), assembly: null, quantity: 1 }];
                this.setState({ addLogEntries: entries });
                setTimeout(() => {
                    const nextInput = document.querySelector(`[data-entry-index="${entries.length - 1}"] input`);
                    if (nextInput) nextInput.focus();
                }, 100);
            } else if (index < this.state.addLogEntries.length - 1) {
                setTimeout(() => {
                    const nextInput = document.querySelector(`[data-entry-index="${index + 1}"] input`);
                    if (nextInput) nextInput.focus();
                }, 100);
            }
        }
    };

    removeAddLogEntry = (index) => {
        const entries = [...this.state.addLogEntries];
        entries.splice(index, 1);
        if (entries.length === 0) {
            entries.push({ id: uuid(), assembly: null, quantity: 1 });
        }
        this.setState({ addLogEntries: entries });
    };

    addPackageLogs = () => {
        const self = this;
        const validEntries = this.state.addLogEntries.filter(entry => entry.assembly);
        if (validEntries.length === 0) {
            return window.$alertWarning("You must select at least one assembly for this log");
        }

        self.setState({ savingLog: true });
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        const userId = AuthenticationService.getInstance().getUserId();
        const logDate = this.state.newLogDateManuallyChanged
            ? dateTimePickerToUtc(this.state.newLogDate)
            : dateTimePickerToUtc(new Date());
        const reason = this.state.newLogReason;

        Promise.all(validEntries.map(entry => {
            return assemblyService.createPackageLog({
                id: uuid(),
                assemblyId: entry.assembly.type === 'assembly' ? entry.assembly.value : null,
                subAssemblyId: entry.assembly.type === 'subassembly' ? entry.assembly.value : null,
                quantity: parseNumberInputValue(entry.quantity),
                logDate,
                checkedBom: false,
                reason,
                userId
            });
        })).then(() => {
            window.$alertSuccess(`${validEntries.length} package log${validEntries.length > 1 ? 's' : ''} created`);
            self.setState({
                addingLogOpen: false,
                savingLog: false,
                addLogEntries: [{ id: uuid(), assembly: null, quantity: 1 }],
                newLogReason: '',
                newLogDate: new Date(),
                newLogDateManuallyChanged: false
            });
            self.loadData();
        }).catch((error) => {
            window.$alertError("Error creating package logs: " + (error.message || 'Unknown error'));
            self.setState({ savingLog: false });
        });
    };

    editPackageLog = (log) => {
        const assembly = this.state.assemblies.find(x => x.assembly.id === log.assemblyId);
        const subAssembly = this.state.subAssemblies.find(x => x.subAssembly.id === log.subAssemblyId);
        
        this.setState({
            editingLog: log,
            editingLogOpen: true,
            savingEditLog: false,
            editLogAssembly: log.assemblyId || log.subAssemblyId,
            editLogType: log.assemblyId ? 'assembly' : 'subAssembly',
            editLogQuantity: log.quantity,
            editLogReason: log.reason,
            editLogDate: fromUtcForDisplay(log.logDate).toDate()
        });
    };

    handleCloseEditLog = () => {
        this.setState({
            editingLogOpen: false, 
            editingLog: null,
            editLogAssembly: null,
            editLogType: '',
            editLogQuantity: 0,
            editLogReason: '',
            editLogDate: new Date()
        });
    };

    handleEditAssemblyChange = (event, newValue) => {
        if (!newValue) this.setState({editLogAssembly: null, editLogType: ''});
        else {
            if (this.state.assemblies.find(x => x.assembly.id === newValue.value) !== undefined) {
                this.setState({editLogAssembly: newValue.value, editLogType: 'assembly'});
            } else {
                this.setState({editLogAssembly: newValue.value, editLogType: 'subAssembly'});
            }
        }
    };

    changeEditQuantity = (event) => {
        this.setState({editLogQuantity: event.target.value});
    };

    changeEditReason = (event) => {
        this.setState({editLogReason: event.target.value});
    };

    updatePackageLog = () => {
        const self = this;
        if (!this.state.editLogAssembly) return window.$alertWarning("You must select an assembly and quantity for this log");

        self.setState({savingEditLog: true});
        const payload = {
            id: this.state.editingLog.id,
            assemblyId: this.state.editLogType === 'assembly' ? this.state.editLogAssembly : null,
            subAssemblyId: this.state.editLogType === 'subAssembly' ? this.state.editLogAssembly : null,
            quantity: parseNumberInputValue(this.state.editLogQuantity),
            logDate: dateTimePickerToUtc(this.state.editLogDate),
            checkedBom: this.state.editingLog.checkedBom,
            reason: this.state.editLogReason,
            userId: this.state.editingLog.userId || AuthenticationService.getInstance().getUserId()
        };
        const assemblyService = ServiceLocator.Instance.getAssemblyService();
        assemblyService.updatePackageLog(payload).then(() => {
            window.$alertSuccess("Package log updated");
            self.setState({
                editingLogOpen: false, 
                savingEditLog: false, 
                editingLog: null,
                editLogAssembly: null,
                editLogType: '',
                editLogQuantity: 0,
                editLogReason: '',
                editLogDate: new Date()
            });
            self.loadData();
        });
    };

    deletePackageLog = (packageLog) => {
        const self = this;
        if (window.confirm(`Are you sure you want to delete this package log?`)) {
            const assemblyService = ServiceLocator.Instance.getAssemblyService();
            assemblyService.deletePackageLog(packageLog).then(() => {
                window.$alertSuccess("Package log deleted");
                self.setState({editingLogOpen: false, savingEditLog: false, editingLog: null});
                this.loadData();
            }).catch((error) => {
                window.$alertError("Failed to delete package log: " + error.message);
            });
        }
    };

    handleAssemblyFamilyChange = (event, newValue) => {
        if (!newValue) this.setState({assemblyFamily: null});
        else {
            const assemblyFamily = this.state.assemblyFamilies.find(x => x.id === newValue.value);
            this.setState({assemblyFamily, assemblyFamilyId: newValue.value});
        }
    };

    roundWithPointSix = (number) => {
        const decimalValue = number - Math.floor(number);
        if (decimalValue < 0.6) return Math.floor(number);
        return Math.round(number);
    }

    // Adjust quantities to ensure sum equals target quantity
    adjustQuantitiesToMatchTarget = (quantities, targetQuantity) => {
        if (!quantities || quantities.length === 0) return quantities;
        
        // Calculate current sum
        const currentSum = quantities.reduce((sum, qty) => sum + qty, 0);
        const difference = targetQuantity - currentSum;
        
        // If no difference, no adjustment needed
        if (Math.abs(difference) < 0.01) return quantities;
        
        // Find the largest quantity (or first if multiple have the same largest value)
        let maxIndex = 0;
        let maxValue = quantities[0];
        
        for (let i = 1; i < quantities.length; i++) {
            if (quantities[i] > maxValue) {
                maxValue = quantities[i];
                maxIndex = i;
            }
        }
        
        // Adjust the largest quantity
        quantities[maxIndex] += difference;
        
        // Ensure the adjusted quantity doesn't go negative
        if (quantities[maxIndex] < 0) {
            quantities[maxIndex] = 0;
        }
        
        return quantities;
    }

    formatWeight = (assembly) => {
        const pounds = assembly.weightPounds || 0;
        const ounces = assembly.weightOunces || 0;
        
        if (pounds === 0 && ounces === 0) return "";
        if (pounds === 0) return `${ounces} oz`;
        if (ounces === 0) return `${pounds} lbs`;
        return `${pounds} ${pounds === 1 ? 'lb' : 'lbs'} ${ounces} oz`;
    };

    openPrintLabels = (packageLog, assemblyExpanded) => {
        const assembly = assemblyExpanded ? assemblyExpanded.assembly : null;
        if (!assembly) return window.$alertError("Unable to retrieve assembly information.");
        
        const userService = ServiceLocator.Instance.getUserService();
        userService.getAdminUsers().then(users => {
            let user = users.find(x => x.id === packageLog.userId);
            if (!user) user = AuthenticationService.getInstance().getUser();

            let containerHtml = '';
            for (let i = 0; i < packageLog.quantity; i++) {
                if (i === 0) containerHtml += `<div class='top-gutter'></div>`;
    
                if (i % 2 === 0) containerHtml += `<div class='left-gutter'></div>`;
    
                const uniqueTag = user.firstName[0].toUpperCase() + user.lastName[0].toUpperCase() + new Date(new Date(packageLog.logDate).setHours(0,0,0,0)).toISOString().slice(0,10).replace(/-/g,"");
                
                // Calculate dynamic font size for description based on length
                const fullDescription = assembly.description || "";
                const descriptionLength = fullDescription.length;
                let fontSize = 13; // Default font size
                
                // Adjust font size based on description length
                if (descriptionLength > 100) {
                    fontSize = 8;
                } else if (descriptionLength > 80) {
                    fontSize = 9;
                } else if (descriptionLength > 60) {
                    fontSize = 10;
                } else if (descriptionLength > 40) {
                    fontSize = 11;
                } else if (descriptionLength > 20) {
                    fontSize = 12;
                }
                
                // Check if install video URL exists
                const hasInstallVideo = assembly.installVideoURL && assembly.installVideoURL.trim() !== "";
                
                containerHtml += `<div class="label-4x2">
                    <div class="rev-tag">${assembly.revision}</div>
                    <div class="label-left">
                        <div><img src="https://jxbstorage.blob.core.windows.net/jxbui/JXB%20BW.png" width="160"/></div>
                        <div style="font-weight: 700; font-size: 28px;">${assembly.assemblyId}</div>
                        <div style="font-size: ${fontSize}px; line-height: 1.2; word-break: break-word; overflow-wrap: break-word;">${fullDescription}</div>
                        <div style="font-size: 17px; font-weight: 1000; margin-top: 3px;">${this.formatWeight(assembly)}</div>
                    </div>
                    <div class="label-right">
                        ${hasInstallVideo ? 
                            `<div style="position: relative;">
                                <img src="https://jxbstorage.blob.core.windows.net/jxbui/Install%20Video.png" width="125"/>
                                <img src='https://api.qrserver.com/v1/create-qr-code/?size=500x500&data=${assembly.installVideoURL}' style="position: absolute; left: 21px; top: 29px; width: 100px; height: 100px;"/>
                            </div>` 
                            : ''
                        }
                    </div>
                    <div class="unique-tag">${uniqueTag}</div>
                </div>`;
    
                if (i % 2 === 0) containerHtml += `<div class='center-gutter'></div>`;
                else containerHtml += `<div class='right-gutter'></div>`;
    
                if (i === packageLog.quantity - 1) containerHtml += `<div class='bottom-gutter'></div>`;
            }
    
            const win = window.open("", "Title", "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,width=384,height=1100");
            win.document.body.innerHTML = `<html><head><style>@media print { @page { margin: 0 !important; } body, html { margin: 0 !important; padding: 0 !important; } }.label-left {width: 54%; display: inline-block; font-size: 13px; padding: 0 9px;} .label-right {width: 37%; display: inline-block; font-size: 11px; font-style: italic;} .labels_page {font-family: Montserrat, sans-serif; width: 4in; position: absolute; top: 0; left: 0; .label-4x2 { height: 2in; text-align: center; display: flex; align-items: center; position: relative; } .unique-tag { position: absolute; right: 16px; bottom: 8px; font-size: 10px; font-style: italic; } .rev-tag { position: absolute; width: 14px; height: 14px; left: 13px; bottom: 8px; font-size: 15px; border: 1px solid black; padding: 5px; line-height: 14px; border-radius: 50%; font-weight: 600; }</style></head><body><div id="container" class="labels_page">` + containerHtml + `</div></body></html>`;
            setTimeout(() => {
                win.print();
            }, 2000);
        });
    };

    handleLogSort = (column) => {
        const isAsc = this.state.logsSortBy === column && this.state.logsSortOrder === 'asc';
        this.setState({
            logsSortBy: column,
            logsSortOrder: isAsc ? 'desc' : 'asc'
        });
    };

    getSortedLogs = () => {
        const logs = [...this.state.packageLogs];
        return logs.sort((a, b) => {
            let valueA, valueB;
            
            switch (this.state.logsSortBy) {
                case 'logDate':
                    valueA = new Date(a.logDate);
                    valueB = new Date(b.logDate);
                    break;
                case 'user':
                    const userA = this.state.adminUsers.find(x => x.id === a.userId);
                    const userB = this.state.adminUsers.find(x => x.id === b.userId);
                    valueA = userA ? `${userA.firstName} ${userA.lastName}` : 'Unknown';
                    valueB = userB ? `${userB.firstName} ${userB.lastName}` : 'Unknown';
                    break;
                case 'partNumber':
                    const assemblyA = this.state.assemblies.find(x => x.assembly.id === a.assemblyId);
                    const subAssemblyA = this.state.subAssemblies.find(x => x.subAssembly.id === a.subAssemblyId);
                    const assemblyB = this.state.assemblies.find(x => x.assembly.id === b.assemblyId);
                    const subAssemblyB = this.state.subAssemblies.find(x => x.subAssembly.id === b.subAssemblyId);
                    valueA = assemblyA ? assemblyA.assembly.assemblyId : (subAssemblyA ? subAssemblyA.subAssembly.subAssemblyId : '');
                    valueB = assemblyB ? assemblyB.assembly.assemblyId : (subAssemblyB ? subAssemblyB.subAssembly.subAssemblyId : '');
                    break;
                default:
                    return 0;
            }
            
            if (valueA < valueB) return this.state.logsSortOrder === 'asc' ? -1 : 1;
            if (valueA > valueB) return this.state.logsSortOrder === 'asc' ? 1 : -1;
            return 0;
        });
    };

    renderSortIcon = (column) => {
        if (this.state.logsSortBy === column) {
            return this.state.logsSortOrder === 'asc' ? 
                <ArrowUpwardIcon style={{fontSize: 16, marginLeft: 4}} /> : 
                <ArrowDownwardIcon style={{fontSize: 16, marginLeft: 4}} />;
        }
        return null;
    };

    render() {
        const {classes} = this.props;
        const self = this;
        if (this.state.loading) {
            return (
                <DashboardTemplate title="Packaging" onSyncDatabase={this.loadData}>
                    <div className="main-dashboard-root">
                        <CircularProgress/>
                    </div>
                </DashboardTemplate>
            );
        }

        let assemblyOptions = [];
        this.state.assemblies.filter(x => x.assembly.isActive).forEach((assembly) => {
            assemblyOptions.push({
                type: 'assembly',
                partId: assembly.assembly.assemblyId,
                revision: assembly.assembly.revision,
                description: assembly.assembly.description,
                value: assembly.assembly.id,
                assemblyData: assembly.assembly,
                currentlyPackaging: assembly.assembly.currentlyPackaging,
                currentlySelling: isAssemblyCurrentlySelling(assembly.assembly, this.state.assemblies)
            });
        });
        this.state.subAssemblies.filter(x => x.subAssembly.isActive).forEach((subAssembly) => {
            assemblyOptions.push({
                type: 'subassembly',
                partId: subAssembly.subAssembly.subAssemblyId,
                revision: subAssembly.subAssembly.revision,
                description: subAssembly.subAssembly.description,
                value: subAssembly.subAssembly.id,
                subAssemblyData: subAssembly.subAssembly,
                currentlyPackaging: subAssembly.subAssembly.currentlyPackaging
            });
        });

        let assemblyFamilyOptions = [];
        this.state.assemblyFamilies.sort((a, b) => a.assemblyFamilyId.localeCompare(b.assemblyFamilyId)).forEach((assemblyFamily) => {
            assemblyFamilyOptions.push({title: assemblyFamily.assemblyFamilyId, value: assemblyFamily.id});
        });

        let totalSalesInFamily = 0.0;
        let totalQuantityOnShelf = 0.0;
        let totalSalesInFamilyToPack = 0.0;
        let totalQuantityOnShelfToPack = 0.0;
        let totalSimulatedPack = 0.0;
        let assembliesToPack = [];
        if (this.state.assemblyFamilyId) {
            // Get all assemblies in this family
            const familyAssemblies = this.state.assemblies.filter(
                x => x.assembly.assemblyFamilyId === this.state.assemblyFamilyId && x.assembly.isActive
            );
            
            // Calculate totals
            familyAssemblies.forEach((assemblyExpanded) => {
                totalSalesInFamily += assemblyExpanded.twentyFourWeekSalesPerWeek;
                totalQuantityOnShelf += assemblyExpanded.quantityOnShelf;
            });
            
            // Sort assemblies by sales (highest to lowest)
            const sortedAssemblies = [...familyAssemblies].sort(
                (a, b) => b.twentyFourWeekSalesPerWeek - a.twentyFourWeekSalesPerWeek
            );
            
            const unpackedQty = Number.parseInt(this.state.calculatorUnpacked);
            let remainingUnpacked = unpackedQty;
            let totalRebalancing = 0;

            // First pass: Identify assemblies to unpack (negative quantities)
            sortedAssemblies.forEach(assemblyExpanded => {
                // Calculate percentage of sales
                const percentOfSales = totalSalesInFamily > 0 ? 
                    assemblyExpanded.twentyFourWeekSalesPerWeek / totalSalesInFamily : 
                    1 / familyAssemblies.length;
                
                // Calculate desired shelf quantity
                let desiredShelfQuantity = (totalQuantityOnShelf + unpackedQty) * percentOfSales;
                let rawQuantityToPack = desiredShelfQuantity - assemblyExpanded.quantityOnShelf;
                
                // Check if we should unpack this assembly
                if (this.state.rebalanceInventory && rawQuantityToPack < 0) {
                    // Calculate how much to unpack (negative value)
                    let unpackQty = Math.round(Math.abs(rawQuantityToPack)) * -1;
                    // Track total available for redistribution
                    totalRebalancing += Math.abs(unpackQty);
                }
            });
            
            // Add the rebalancing quantity to the remaining unpacked for redistribution
            remainingUnpacked += totalRebalancing;

            // Calculate total raw quantity needed for assemblies that need more
            let totalRawQuantity = 0;
            let assembliesNeedingMore = [];
            
            sortedAssemblies.forEach(assemblyExpanded => {
                const percentOfSales = totalSalesInFamily > 0 ? 
                    assemblyExpanded.twentyFourWeekSalesPerWeek / totalSalesInFamily : 
                    1 / familyAssemblies.length;
                
                let desiredShelfQuantity = (totalQuantityOnShelf + unpackedQty) * percentOfSales;
                let rawQuantityToPack = desiredShelfQuantity - assemblyExpanded.quantityOnShelf;
                
                if (rawQuantityToPack > 0) {
                    assembliesNeedingMore.push({
                        assembly: assemblyExpanded,
                        rawQty: rawQuantityToPack,
                        percentOfSales: percentOfSales
                    });
                    totalRawQuantity += rawQuantityToPack;
                }
            });
            
            // Second pass: Distribute quantities
            assembliesNeedingMore.forEach(item => {
                const assemblyExpanded = item.assembly;
                let quantityToPack;
                
                if (this.state.rebalanceInventory) {
                    // When rebalancing, use the raw quantity but don't exceed remaining unpacked
                    quantityToPack = Math.min(this.roundWithPointSix(item.rawQty), remainingUnpacked);
                } else {
                    // When not rebalancing, distribute unpacked quantity proportionally
                    quantityToPack = Math.round(unpackedQty * (item.rawQty / totalRawQuantity));
                }
                
                if (quantityToPack > 0) {
                    remainingUnpacked -= quantityToPack;
                    totalSimulatedPack += quantityToPack;
                    
                    // Add to list of assemblies to pack
                    assembliesToPack.push(assemblyExpanded);
                    totalSalesInFamilyToPack += assemblyExpanded.twentyFourWeekSalesPerWeek;
                    totalQuantityOnShelfToPack += assemblyExpanded.quantityOnShelf;
                }
            });
        }

        return (
            <DashboardTemplate title="Packaging" onSyncDatabase={this.loadData}>
                <div className="main-dashboard-root">
                    <div className="container" style={{maxWidth: '1500px'}}>
                        <div className={classes.toolbar}>
                            <div style={{position: 'relative', display: 'flex', alignItems: 'center', width: '100%'}}>
                                {/* Left: Search Bar */}
                                <div style={{flex: '1', display: 'flex', justifyContent: 'flex-start', minHeight: 55}}>
                                    {this.state.showingLogs === true && (
                                        <TextField
                                            defaultValue=''
                                            onChange={this.searchLogs}
                                            label="Search logs..."
                                            variant="outlined"
                                            style={{width: '300px'}}
                                        />
                                    )}
                                    {!this.state.showingLogs && !this.state.showingCalculator && (
                                        <TextField
                                            value={this.state.searchTerm}
                                            onChange={this.searchAssembly}
                                            label="Search PN or Description..."
                                            variant="outlined"
                                            style={{width: '300px'}}
                                            inputRef={ref => this.searchInputRef = ref}
                                        />
                                    )}
                                </div>
                                
                                {/* Center: Buttons - Absolutely centered */}
                                <div style={{position: 'absolute', left: '50%', transform: 'translateX(-50%)'}}>
                                    {this.state.showingLogs === true && (
                                        <div style={{display: 'flex', gap: '10px'}}>
                                            <Button 
                                                variant="contained"
                                                color="primary"
                                                onClick={() => {globalProps.history.push('/admin/packaging'); this.setState({showingLogs: false, showingCalculator: false})}}
                                                className="success-button-lg"
                                            >
                                                Show Worksheet
                                            </Button>
                                            <Button 
                                                variant="contained"
                                                color="primary"
                                                onClick={this.openAddLog} 
                                                className="success-button-lg"
                                            >
                                                Add Log
                                            </Button>
                                        </div>
                                    )}
                                    {this.state.showingCalculator === true && (
                                        <Button 
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {globalProps.history.push('/admin/packaging'); this.setState({showingLogs: false, showingCalculator: false})}}
                                            className="success-button-lg"
                                        >
                                            Show Worksheet
                                        </Button>
                                    )}
                                    {!this.state.showingLogs && !this.state.showingCalculator && (
                                        <div style={{display: 'flex', gap: '10px'}}>
                                            <Button 
                                                variant="contained"
                                                color="primary"
                                                onClick={() => {globalProps.history.push('/admin/packaging/logs'); this.setState({showingLogs: true, showingCalculator: false})}}
                                                className="success-button-lg"
                                            >
                                                Show Logs
                                            </Button>
                                            <Button 
                                                variant="contained"
                                                color="primary"
                                                onClick={() => this.setState({showingLogs: false, showingCalculator: true})}
                                                className="success-button-lg"
                                            >
                                                Show Calculator
                                            </Button>
                                        </div>
                                    )}
                                </div>
                                
                                {/* Right: Filter toggles */}
                                <div style={{flex: '1', display: 'flex', justifyContent: 'flex-end', gap: '20px', alignItems: 'center'}}>
                                    {!this.state.showingLogs && !this.state.showingCalculator && (
                                        <>
                                            <div className={classes.filterToggle} onClick={this.toggleOldRevs}>
                                                <Checkbox
                                                    checked={this.state.showOldRevs}
                                                    onChange={this.toggleOldRevs}
                                                />
                                                <span className={classes.filterLabel}>Show Old Revisions</span>
                                            </div>
                                            <div className={classes.filterToggle} onClick={this.toggleDeactivated}>
                                                <Checkbox
                                                    checked={this.state.showDeactivated}
                                                    onChange={this.toggleDeactivated}
                                                />
                                                <span className={classes.filterLabel}>Show Deactivated</span>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {this.state.showingLogs === true ?
                            <div>
                                <center>
                                    <TablePagination
                                        rowsPerPageOptions={[50, 100, 200, 500]}
                                        colSpan={6}
                                        count={this.getSortedLogs().filter(packageLog => {
                                            if (!this.state.logsSearchTerm) return true;
                                            const assembly = this.state.assemblies.find(x => x.assembly.id === packageLog.assemblyId);
                                            const subAssembly = this.state.subAssemblies.find(x => x.subAssembly.id === packageLog.subAssemblyId);
                                            if (!assembly && !subAssembly) return false;
                                            const adminUser = this.state.adminUsers.find(x => x.id === packageLog.userId);
                                            const partNumber = assembly ? `${assembly.assembly.assemblyId || ''} rev ${assembly.assembly.revision || ''}` : `${subAssembly.subAssembly.subAssemblyId || ''} rev ${subAssembly.subAssembly.revision || ''}`;
                                            const description = assembly ? (assembly.assembly.description || '') : (subAssembly.subAssembly.description || '');
                                            const userName = adminUser ? `${adminUser.firstName} ${adminUser.lastName}` : 'Unknown';
                                            const searchTerm = this.state.logsSearchTerm.toLowerCase();
                                            return partNumber.toLowerCase().includes(searchTerm) ||
                                                   description.toLowerCase().includes(searchTerm) ||
                                                   userName.toLowerCase().includes(searchTerm) ||
                                                   packageLog.quantity.toString().includes(this.state.logsSearchTerm);
                                        }).length}
                                        rowsPerPage={this.state.logsRowsPerPage}
                                        page={this.state.logsPage}
                                        slotProps={{
                                            select: {
                                                'aria-label': 'rows per page',
                                            },
                                            actions: {
                                                showFirstButton: true,
                                                showLastButton: true,
                                                slots: {
                                                    firstPageIcon: FirstPageIcon,
                                                    lastPageIcon: LastPageIcon,
                                                    nextPageIcon: ChevronRightIcon,
                                                    backPageIcon: ChevronLeftIcon,
                                                },
                                            },
                                        }}
                                        onChangePage={this.handleLogsChangePage}
                                        onChangeRowsPerPage={this.handleLogsChangeRowsPerPage}
                                    />
                                </center>
                                <div className="parts-table-container">
                                    <table className="parts-table">
                                        <thead>
                                        <tr>
                                            <th style={{minWidth: 30}}>Edit</th>
                                            <th style={{minWidth: 150, cursor: 'pointer'}} onClick={() => this.handleLogSort('logDate')}>
                                                Date {this.renderSortIcon('logDate')}
                                            </th>
                                            <th style={{minWidth: 120, cursor: 'pointer'}} onClick={() => this.handleLogSort('user')}>
                                                User {this.renderSortIcon('user')}
                                            </th>
                                            <th style={{minWidth: 80}}>Quantity</th>
                                            <th style={{minWidth: 250, cursor: 'pointer'}} onClick={() => this.handleLogSort('partNumber')}>
                                                Part {this.renderSortIcon('partNumber')}
                                            </th>
                                            <th style={{minWidth: 200}}>Reason</th>
                                            <th style={{minWidth: 90}}>Print Labels</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {this.getSortedLogs().filter(packageLog => {
                                            // Hide logs with quantity 0 (confirmation logs from inventory sessions)
                                            if (packageLog.quantity === 0) return false;
                                            
                                            if (!this.state.logsSearchTerm) return true;
                                            const assembly = this.state.assemblies.find(x => x.assembly.id === packageLog.assemblyId);
                                            const subAssembly = this.state.subAssemblies.find(x => x.subAssembly.id === packageLog.subAssemblyId);
                                            if (!assembly && !subAssembly) return false;
                                            const adminUser = this.state.adminUsers.find(x => x.id === packageLog.userId);
                                            const partNumber = assembly ? `${assembly.assembly.assemblyId || ''} rev ${assembly.assembly.revision || ''}` : `${subAssembly.subAssembly.subAssemblyId || ''} rev ${subAssembly.subAssembly.revision || ''}`;
                                            const description = assembly ? (assembly.assembly.description || '') : (subAssembly.subAssembly.description || '');
                                            const userName = adminUser ? `${adminUser.firstName} ${adminUser.lastName}` : 'Unknown';
                                            const searchTerm = this.state.logsSearchTerm.toLowerCase();
                                            return partNumber.toLowerCase().includes(searchTerm) ||
                                                   description.toLowerCase().includes(searchTerm) ||
                                                   userName.toLowerCase().includes(searchTerm) ||
                                                   packageLog.quantity.toString().includes(this.state.logsSearchTerm);
                                        }).slice(this.state.logsPage * this.state.logsRowsPerPage, this.state.logsPage * this.state.logsRowsPerPage + this.state.logsRowsPerPage).map((packageLog) => {
                                            const assembly = this.state.assemblies.find(x => x.assembly.id === packageLog.assemblyId);
                                            const subAssembly = this.state.subAssemblies.find(x => x.subAssembly.id === packageLog.subAssemblyId);
                                            if (!assembly && !subAssembly) return '';

                                            const adminUser = this.state.adminUsers.find(x => x.id === packageLog.userId);

                                            return (
                                                <tr key={packageLog.id}>
                                                    <td><span style={{cursor: 'pointer'}} onClick={() => this.editPackageLog(packageLog)}><EditIcon /></span></td>
                                                    <td>{formatUtcForDisplay(packageLog.logDate)}</td>
                                                    <td>{adminUser ? `${adminUser.firstName} ${adminUser.lastName}` : 'Unknown'}</td>
                                                    <td>{packageLog.quantity}</td>
                                                    <td className="text-left">
                                                        {this.state.permissions.includes('EditAssembliesAndParts') ? (
                                                            <div style={{cursor: 'pointer'}} onClick={(event) => this.editAssembly(assembly, subAssembly, event.ctrlKey)}>
                                                                <PartDisplay 
                                                                    part={assembly ? {
                                                                        partId: assembly.assembly.assemblyId,
                                                                        revision: assembly.assembly.revision,
                                                                        description: assembly.assembly.description
                                                                    } : {
                                                                        partId: subAssembly.subAssembly.subAssemblyId,
                                                                        revision: subAssembly.subAssembly.revision,
                                                                        description: subAssembly.subAssembly.description
                                                                    }}
                                                                    variant="table"
                                                                    classes={this.props.classes}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <PartDisplay 
                                                                part={assembly ? {
                                                                    partId: assembly.assembly.assemblyId,
                                                                    revision: assembly.assembly.revision,
                                                                    description: assembly.assembly.description
                                                                } : {
                                                                    partId: subAssembly.subAssembly.subAssemblyId,
                                                                    revision: subAssembly.subAssembly.revision,
                                                                    description: subAssembly.subAssembly.description
                                                                }}
                                                                variant="table"
                                                                classes={this.props.classes}
                                                            />
                                                        )}
                                                    </td>
                                                    <td className="text-left">{packageLog.reason}</td>
                                                    <td><span style={{cursor: 'pointer'}} onClick={() => this.openPrintLabels(packageLog, assembly)}>{assembly ? <PrintIcon /> : ''}</span></td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                                {this.state.addingLogOpen ?
                                    <DrawerMenuRight title={"Add Package Log"} customWidth={600}
                                                     open={this.state.addingLogOpen}
                                                     onClose={this.handleCloseNewLog}
                                                     hasUnsavedChanges={
                                                         this.state.newLogReason !== '' ||
                                                         this.state.newLogDateManuallyChanged ||
                                                         this.state.addLogEntries.some(entry => entry.assembly || (entry.quantity !== '' && entry.quantity !== 1))
                                                     }
                                                     onSubmit={false}
                                                     >
                                        <div style={{width: '100%', marginBottom: 20}}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DateTimePicker
                                                    label="Log Date"
                                                    value={this.state.newLogDate}
                                                    onChange={(newValue) => this.setState({newLogDate: newValue, newLogDateManuallyChanged: true})}
                                                    renderInput={(params) => (
                                                        <TextField 
                                                            {...params} 
                                                            variant="outlined" 
                                                            fullWidth
                                                        />
                                                    )}
                                                    style={{width: '100%'}}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <TextField value={this.state.newLogReason || ''}
                                                onChange={this.changeNewLogReason} label={"Reason"}
                                                variant="outlined" type="text"
                                                style={{width: '100%', marginBottom: 20}}/>
                                        <div style={{marginBottom: 20}}>
                                            <h3 style={{margin: '0 0 15px 0', color: '#333'}}>Items</h3>
                                            {this.state.addLogEntries.map((entry, index) => (
                                                <div key={entry.id} data-entry-index={index} style={{
                                                    display: 'flex',
                                                    gap: '10px',
                                                    alignItems: 'center',
                                                    marginBottom: '10px',
                                                    padding: '10px',
                                                    border: '1px solid #e0e0e0',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#fafafa'
                                                }}>
                                                    <div style={{flex: '2'}}>
                                                        <Autocomplete autoHighlight
                                                            options={assemblyOptions}
                                                            onChange={(event, newValue) => this.handleAddLogAssemblyChange(index, newValue)}
                                                            value={entry.assembly}
                                                            getOptionLabel={(option) => option.partId ? `${option.currentlyPackaging ? '📦 ' : ''}${option.currentlySelling ? '🛒 ' : ''}${option.partId} rev ${option.revision}` : ''}
                                                            getOptionSelected={(option) => option && entry.assembly && option.value === entry.assembly.value}
                                                            className="autocomplete-dropdown"
                                                            renderOption={(option) => <PartAutocompleteOption option={option} classes={this.props.classes} />}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter' || event.key === 'Tab') {
                                                                    event.stopPropagation();
                                                                    event.preventDefault();
                                                                    if (event.shiftKey && event.key === 'Tab' && index > 0) {
                                                                        setTimeout(() => {
                                                                            const prev = document.querySelector(`[data-entry-index="${index - 1}"] input[type="number"]`);
                                                                            if (prev) prev.focus();
                                                                        }, 100);
                                                                        return;
                                                                    }
                                                                    const quantityField = event.target.closest('[data-entry-index]').querySelector('input[type="number"]');
                                                                    if (quantityField) setTimeout(() => quantityField.focus(), 100);
                                                                }
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label="Assembly" variant="outlined" autoComplete="new-password" size="small" />
                                                            )}
                                                        />
                                                    </div>
                                                    <div style={{flex: '1'}}>
                                                        <TextField
                                                            label="Quantity (+/-)"
                                                            variant="outlined"
                                                            type="number"
                                                            value={getNumberInputDisplayValue(entry.quantity)}
                                                            onChange={(event) => this.handleAddLogQuantityChange(index, event)}
                                                            onKeyDown={(event) => this.handleAddLogQuantityKeyDown(index, event)}
                                                            size="small"
                                                            fullWidth
                                                            inputProps={{'data-entry-index': index}}
                                                        />
                                                    </div>
                                                    {this.state.addLogEntries.length > 1 && (
                                                        <Button
                                                            variant="outlined"
                                                            color="secondary"
                                                            size="small"
                                                            onClick={() => this.removeAddLogEntry(index)}
                                                            style={{minWidth: '40px'}}
                                                        >
                                                            ×
                                                        </Button>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                        <div style={{textAlign: 'center', marginTop: '20px'}}>
                                            {this.state.savingLog === true ?
                                                <CircularProgress/>
                                                :
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.addPackageLogs}
                                                    className="success-button-lg"
                                                    disabled={!this.state.addLogEntries.some(entry => entry.assembly)}
                                                >
                                                    Confirm All Entries ({this.state.addLogEntries.filter(entry => entry.assembly).length} items)
                                                </Button>
                                            }
                                        </div>
                                    </DrawerMenuRight>
                                    : ""}
                                {this.state.editingLogOpen ?
                                    <DrawerMenuRight title={"Edit Package Log"} customWidth={500}
                                                     open={this.state.editingLogOpen}
                                                     onClose={this.handleCloseEditLog}
                                                     hasUnsavedChanges={
                                                         this.state.editLogAssembly !== (this.state.editingLog?.assemblyId || this.state.editingLog?.subAssemblyId) ||
                                                         this.state.editLogQuantity !== this.state.editingLog?.quantity ||
                                                         this.state.editLogReason !== this.state.editingLog?.reason ||
                                                         this.state.editLogDate.getTime() !== fromUtcForDisplay(this.state.editingLog?.logDate).toDate().getTime()
                                                     }
                                                     onSubmit={this.updatePackageLog}
                                                     submitConfirmMessage="Are you sure you want to save these changes?"
                                                     >
                                        <div style={{display: 'flex', alignItems: 'center', marginBottom: 20}}>
                                            <Autocomplete autoHighlight
                                                id="ddlEditAssembly"
                                                style={{width: '72%', display: 'inline-block'}}
                                                options={assemblyOptions}
                                                onChange={this.handleEditAssemblyChange}
                                                value={assemblyOptions.find(option => option.value === this.state.editLogAssembly) || null}
                                                getOptionLabel={(option) => option.partId ? `${option.currentlyPackaging ? '📦 ' : ''}${option.currentlySelling ? '🛒 ' : ''}${option.partId} rev ${option.revision}` : ''}
                                                getOptionSelected={(option) => option.value === this.state.editLogAssembly}
                                                className="autocomplete-dropdown"
                                                renderOption={(option) => <PartAutocompleteOption option={option} classes={this.props.classes} />}
                                                renderInput={(params) => <TextField {...params} inputProps={{
                                                    ...params.inputProps
                                                }} label="Assembly" autoComplete="new-password" variant="outlined"/>}
                                            />
                                            <TextField value={this.state.editLogQuantity || ''}
                                                    onChange={(event) => this.setState({editLogQuantity: event.target.value})} label={"Quantity (+/-)"}
                                                    variant="outlined" type="number"
                                                    style={{width: '27%', marginLeft: 10}}/>
                                        </div>
                                        <div style={{width: '100%', marginBottom: 20}}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DateTimePicker
                                                    label="Log Date"
                                                    value={this.state.editLogDate}
                                                    onChange={(newValue) => this.setState({editLogDate: newValue})}
                                                    renderInput={(params) => (
                                                        <TextField 
                                                            {...params} 
                                                            variant="outlined" 
                                                            fullWidth
                                                        />
                                                    )}
                                                    style={{width: '100%'}}
                                                />
                                            </MuiPickersUtilsProvider>
                                        </div>
                                        <TextField value={this.state.editLogReason || ''}
                                                onChange={this.changeEditReason} label={"Reason"}
                                                variant="outlined" type="text"
                                                style={{width: '100%', marginBottom: 20}}/>
                                        <center>
                                            {this.state.savingEditLog === true ?
                                                <CircularProgress/>
                                                :
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={this.updatePackageLog}
                                                    className="success-button-lg"
                                                    style={{width: 150, display: 'inline-block'}}
                                                >
                                                    Save
                                                </Button>
                                            }
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => this.deletePackageLog(this.state.editingLog)}
                                                className="delete-button-lg"
                                                style={{margin: '0 0 0 10px'}}
                                            >
                                                Delete
                                            </Button>
                                        </center>
                                    </DrawerMenuRight>
                                    : ""}
                            </div>
                            :
                            <div>
                                {this.state.showingCalculator === true ?
                                    <div>
                                        <Autocomplete autoHighlight
                                            id="ddlAssemblyFamily"
                                            style={{marginBottom: 20, marginTop: 10, maxWidth: 500}}
                                            options={assemblyFamilyOptions}
                                            onChange={this.handleAssemblyFamilyChange}
                                            getOptionLabel={(option) => option.title}
                                            getOptionSelected={(option) => option.value === this.state.assemblyFamilyId}
                                            className="autocomplete-dropdown"
                                            renderInput={(params) => <TextField {...params} inputProps={{
                                                ...params.inputProps
                                            }} label="Assembly Family" autoComplete="new-password"
                                                                                variant="outlined"/>}
                                        />
                                        {this.state.assemblyFamily ?
                                            <div>
                                                <TextField value={this.state.calculatorUnpacked}
                                                           onChange={(event) => this.setState({calculatorUnpacked: parseNumberInputValue(event.target.value)})}
                                                           variant="outlined"
                                                           label="Unpacked Quantity"/>
                                                <br /><br />
                                                <Checkbox onClick={(event) => {
                                                    this.setState({rebalanceInventory: event.target.checked})
                                                }} checked={this.state.rebalanceInventory} style={{padding: 0}}/> Rebalance Inventory
                                                <br/>
                                                <table className="parts-table" style={{marginTop: 20, textAlign: 'center', maxWidth: 600, margin: '0 auto'}}>
                                                    <thead>
                                                    <tr style={{backgroundColor: "#000", color: "#FFF"}}>
                                                        <th style={{minWidth: 130}}>PN</th>
                                                        <th style={{minWidth: 80}}>Qty On<br/>Shelf</th>
                                                        <th style={{minWidth: 80}}>24 week<br/>Sales/Wk</th>
                                                        <th style={{minWidth: 80}}>% of Sales</th>
                                                        <th style={{minWidth: 80}}>Desired<br/>Shelf Qty</th>
                                                        <th style={{minWidth: 80}}>Qty to<br/>Pack</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {(() => {
                                                        // Calculate all quantities first, then adjust them to match target
                                                        const assembliesToDisplay = self.state.assemblies.filter(x => x.assembly.assemblyFamilyId === this.state.assemblyFamilyId && x.assembly.isActive).sort(function (a, b) {return a.assembly.assemblyFamilyOrder - b.assembly.assemblyFamilyOrder});
                                                        
                                                        // Calculate quantities for all assemblies
                                                        const quantities = assembliesToDisplay.map((assemblyExpanded) => {
                                                            const assembly = assemblyExpanded.assembly;
                                                            
                                                            // Get all assemblies in family sorted by sales (highest first)
                                                            const familyAssemblies = this.state.assemblies.filter(
                                                                x => x.assembly.assemblyFamilyId === this.state.assemblyFamilyId && x.assembly.isActive
                                                            );
                                                            
                                                            const familyAssembliesSorted = [...familyAssemblies].sort(
                                                                (a, b) => b.twentyFourWeekSalesPerWeek - a.twentyFourWeekSalesPerWeek
                                                            );
                                                            
                                                            // Find the index of current assembly in the sorted list
                                                            const currentAssemblyIndex = familyAssembliesSorted.findIndex(
                                                                x => x.assembly.id === assembly.id
                                                            );
                                                            
                                                            // Calculate quantity to pack for assemblies up to this one
                                                            const unpackedQty = Number.parseInt(this.state.calculatorUnpacked);
                                                            let remainingUnpacked = unpackedQty;
                                                            
                                                            // First pass: Identify which assemblies should be unpacked
                                                            let totalRebalancing = 0;
                                                            for (let i = 0; i < familyAssembliesSorted.length; i++) {
                                                                const assembly = familyAssembliesSorted[i];
                                                                const pct = totalSalesInFamily > 0 ? 
                                                                    assembly.twentyFourWeekSalesPerWeek / totalSalesInFamily : 
                                                                    1 / familyAssemblies.length;
                                                                    
                                                                const desired = (totalQuantityOnShelf + unpackedQty) * pct;
                                                                let qtyToPack = desired - assembly.quantityOnShelf;
                                                                
                                                                if (this.state.rebalanceInventory && qtyToPack < 0) {
                                                                    let unpackQty = Math.round(Math.abs(qtyToPack)) * -1;
                                                                    totalRebalancing += Math.abs(unpackQty);
                                                                }
                                                            }
                                                            
                                                            // Calculate available inventory to redistribute
                                                            remainingUnpacked += totalRebalancing;
                                                            
                                                            // Calculate quantity for current assembly
                                                            const currentAssembly = familyAssembliesSorted[currentAssemblyIndex];
                                                            const pct = totalSalesInFamily > 0 ? 
                                                                currentAssembly.twentyFourWeekSalesPerWeek / totalSalesInFamily : 
                                                                1 / familyAssemblies.length;
                                                                
                                                            const desired = (totalQuantityOnShelf + unpackedQty) * pct;
                                                            let qtyToPack = desired - currentAssembly.quantityOnShelf;
                                                            
                                                            if (qtyToPack > 0) {
                                                                if (this.state.rebalanceInventory) {
                                                                    // When rebalancing, use the raw quantity but don't exceed remaining unpacked
                                                                    let roundedQty = this.roundWithPointSix(qtyToPack);
                                                                    return Math.min(roundedQty, remainingUnpacked);
                                                                } else {
                                                                    // When not rebalancing, distribute based on sales percentage
                                                                    // First calculate the total desired quantity for all assemblies that need more
                                                                    let totalDesiredQty = 0;
                                                                    let assembliesNeedingMore = [];
                                                                    
                                                                    for (let i = 0; i < familyAssembliesSorted.length; i++) {
                                                                        const assembly = familyAssembliesSorted[i];
                                                                        const assemblyPct = totalSalesInFamily > 0 ? 
                                                                            assembly.twentyFourWeekSalesPerWeek / totalSalesInFamily : 
                                                                            1 / familyAssemblies.length;
                                                                        const assemblyDesired = (totalQuantityOnShelf + unpackedQty) * assemblyPct;
                                                                        const assemblyQtyToPack = assemblyDesired - assembly.quantityOnShelf;
                                                                        if (assemblyQtyToPack > 0) {
                                                                            assembliesNeedingMore.push({
                                                                                assembly: assembly,
                                                                                desiredQty: assemblyQtyToPack,
                                                                                pct: assemblyPct
                                                                            });
                                                                            totalDesiredQty += assemblyQtyToPack;
                                                                        }
                                                                    }
                                                                    
                                                                    // Calculate this assembly's share of the unpacked quantity
                                                                    if (totalDesiredQty > 0) {
                                                                        // Calculate proportional share based on desired quantity
                                                                        const proportionalShare = qtyToPack / totalDesiredQty;
                                                                        const rawQty = unpackedQty * proportionalShare;
                                                                        
                                                                        // If this is the last assembly that needs more, use remaining unpacked
                                                                        if (currentAssemblyIndex === assembliesNeedingMore[assembliesNeedingMore.length - 1]?.assembly.id) {
                                                                            return remainingUnpacked;
                                                                        } else {
                                                                            // For all other assemblies, round down to ensure we don't exceed unpacked quantity
                                                                            return Math.floor(rawQty);
                                                                        }
                                                                    } else {
                                                                        return 0;
                                                                    }
                                                                }
                                                            } else if (this.state.rebalanceInventory && qtyToPack < 0) {
                                                                // Handle unpacking when rebalancing
                                                                return Math.round(Math.abs(qtyToPack)) * -1;
                                                            } else {
                                                                return 0;
                                                            }
                                                        });
                                                        
                                                        // Adjust quantities to ensure sum equals target quantity
                                                        const targetQuantity = Number.parseInt(this.state.calculatorUnpacked);
                                                        const adjustedQuantities = this.adjustQuantitiesToMatchTarget(quantities, targetQuantity);
                                                        
                                                        // Return the mapped components with adjusted quantities
                                                        return assembliesToDisplay.map((assemblyExpanded, index) => {
                                                            const assembly = assemblyExpanded.assembly;
                                                            const quantityToPack = adjustedQuantities[index];
                                                            
                                                            const percentOfSalesDisplay = totalSalesInFamily > 0 ? assemblyExpanded.twentyFourWeekSalesPerWeek / totalSalesInFamily : 1 / this.state.assemblies.filter(x => x.assembly.assemblyFamilyId === this.state.assemblyFamilyId && x.assembly.isActive).length;
                                                            let desiredShelfQuantityDisplay = (totalQuantityOnShelf + Number.parseInt(this.state.calculatorUnpacked)) * percentOfSalesDisplay;

                                                            return (
                                                            <tr>
                                                                <td className="text-left">{assembly.assemblyId} rev {assembly.revision}</td>
                                                                <td><TextField
                                                                    value={assemblyExpanded.quantityOnShelf}
                                                                    onChange={(event) => {
                                                                        assemblyExpanded.quantityOnShelf = parseNumberInputValue(event.target.value);
                                                                        this.setState({updated: new Date()});
                                                                    }} variant="outlined"
                                                                    style={{
                                                                        width: 60,
                                                                        margin: '0 auto',
                                                                        display: 'block'
                                                                    }}/>
                                                                </td>
                                                                <td>{assemblyExpanded.twentyFourWeekSalesPerWeek.toFixed(2)}</td>
                                                                <td>{(percentOfSalesDisplay * 100).toFixed(0)}%</td>
                                                                <td>{desiredShelfQuantityDisplay.toFixed(0)}</td>
                                                                <td style={{backgroundColor: '#92D050'}}><b>{this.roundWithPointSix(quantityToPack).toFixed(0)}</b></td>
                                                            </tr>
                                                        );
                                                    });
                                                })()}
                                                    </tbody>
                                                </table>
                                            </div>
                                            : ""}
                                    </div>
                                    :
                                    <div>
                                        <center>
                                            <TablePagination
                                                rowsPerPageOptions={[50, 100, 200, 500]}
                                                colSpan={50}
                                                count={this.state.assembliesAndSubAssemblies.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                slotProps={{
                                                    select: {
                                                        'aria-label': 'rows per page',
                                                    },
                                                    actions: {
                                                        showFirstButton: true,
                                                        showLastButton: true,
                                                        slots: {
                                                            firstPageIcon: FirstPageIcon,
                                                            lastPageIcon: LastPageIcon,
                                                            nextPageIcon: ChevronRightIcon,
                                                            backPageIcon: ChevronLeftIcon,
                                                        },
                                                    },
                                                }}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </center>
                                        <div className="parts-table-container">
                                            <table className="parts-table">
                                                <thead>
                                                <tr>
                                                    <th style={{minWidth: 350}}>Part</th>
                                                    <th style={{minWidth: 60}}>Total To<br/>Package</th>
                                                    <th style={{minWidth: 65}}>Materials<br/>Available</th>
                                                    <th style={{minWidth: 70}}>Total Ass'd<br/>On Hand</th>
                                                    <th style={{minWidth: 70}}>Min Ass'd<br/>On Hand</th>
                                                    <th style={{minWidth: 70}}>Tgt Ass'd<br/>On Hand</th>
                                                    <th style={{minWidth: 70}}>Avg Ass'd<br/>On Hand</th>
                                                    <th style={{minWidth: 80}}>4 week<br/>Sales / wk</th>
                                                    <th style={{minWidth: 80}}>24 week<br/>Sales / wk</th>
                                                    <th style={{minWidth: 50}}>Min Wks<br/>Ahead</th>
                                                    <th style={{minWidth: 50}}>Tgt Wks<br/>Ahead</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {self.state.subAssemblies.map((assemblyExpanded) => {
                                                    if (!this.state.assembliesAndSubAssemblies.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).find(x => x === assemblyExpanded))
                                                        return '';

                                                    const assembly = assemblyExpanded.subAssembly;
                                                    if (!assembly || !assembly.isActive) return '';

                                                    const averageSalesFourAndTwentyFour = (assemblyExpanded.fourWeekSalesPerWeekWithRev + assemblyExpanded.twentyFourWeekSalesPerWeekWithRev) / 2;
                                                    let targetAssembledOnHand = parseNumberInputValue(assemblyExpanded.tgtAhead) * averageSalesFourAndTwentyFour < 2 ? 2 : parseNumberInputValue(assemblyExpanded.tgtAhead) * averageSalesFourAndTwentyFour;
                                                    let minAssembledOnHand = parseNumberInputValue(assemblyExpanded.minAhead) * averageSalesFourAndTwentyFour < 1 ? 1 : parseNumberInputValue(assemblyExpanded.minAhead) * averageSalesFourAndTwentyFour;
                                                    let avgAssembledOnHand = (minAssembledOnHand + targetAssembledOnHand) / 2;
                                                    let totalToPackage = 0;

                                                    let materialsAvailable = "-";
                                                    if (assembly.currentlyPackaging) {
                                                        totalToPackage = assemblyExpanded.totalAssembledOnHandWithRev < targetAssembledOnHand ? targetAssembledOnHand - assemblyExpanded.totalAssembledOnHandWithRev : 0;
                                                        if (totalToPackage > 0) {
                                                            materialsAvailable = 'Yes';
                                                            assembly.partsToSubAssemblies.forEach((assemblyPart) => {
                                                                if (isImpliedPartRelation(assemblyPart)) return;
                                                                const expandedPart = this.state.parts.find(x => x.part.id === assemblyPart.partFk);
                                                                const totalNeededToPackage = Math.ceil(totalToPackage) * assemblyPart.quantity;
                                                                if (expandedPart.totalUnpackaged < totalNeededToPackage) {
                                                                    materialsAvailable = "No";
                                                                }
                                                            });
                                                        }
                                                    }

                                                    return (
                                                        <tr>
                                                            <td className="text-left">
                                                                {this.state.permissions.includes('EditAssembliesAndParts') ? (
                                                                    <div style={{cursor: 'pointer'}} onClick={(event) => this.editAssembly(null, assemblyExpanded, event.ctrlKey)}>
                                                                        <PartDisplay 
                                                                            part={{
                                                                                partId: assembly.subAssemblyId,
                                                                                revision: assembly.revision,
                                                                                description: assembly.description
                                                                            }}
                                                                            variant="table"
                                                                            classes={this.props.classes}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <PartDisplay 
                                                                        part={{
                                                                            partId: assembly.subAssemblyId,
                                                                            revision: assembly.revision,
                                                                            description: assembly.description
                                                                        }}
                                                                        variant="table"
                                                                        classes={this.props.classes}
                                                                    />
                                                                )}
                                                            </td>
                                                            <td>{totalToPackage === 0 ? '-' : totalToPackage.toFixed(0)}</td>
                                                            <td>{materialsAvailable}</td>
                                                            <td>{assemblyExpanded.totalAssembledOnHandWithRev.toFixed(0)}</td>
                                                            <td>{minAssembledOnHand.toFixed(0)}</td>
                                                            <td>{targetAssembledOnHand.toFixed(0)}</td>
                                                            <td>{avgAssembledOnHand.toFixed(0)}</td>
                                                            <td>{assemblyExpanded.fourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                            <td>{assemblyExpanded.twentyFourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                            <td><TextField value={assemblyExpanded.minAhead || ''}
                                                                           onChange={(event) => {
                                                                               assemblyExpanded.minAhead = event.target.value;
                                                                               this.setState({updated: new Date()});
                                                                           }} variant="outlined" style={{
                                                                width: 60,
                                                                margin: '0 auto',
                                                                display: 'block'
                                                            }}/></td>
                                                            <td><TextField value={assemblyExpanded.tgtAhead || ''}
                                                                           onChange={(event) => {
                                                                               assemblyExpanded.tgtAhead = event.target.value;
                                                                               this.setState({updated: new Date()});
                                                                           }} variant="outlined" style={{
                                                                width: 60,
                                                                margin: '0 auto',
                                                                display: 'block'
                                                            }}/></td>
                                                        </tr>
                                                    )
                                                })}
                                                {self.state.assemblies.map((assemblyExpanded) => {
                                                    if (!this.state.assembliesAndSubAssemblies.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).find(x => x === assemblyExpanded))
                                                        return '';

                                                    const assembly = assemblyExpanded.assembly;
                                                    if (!assembly || !assembly.isActive) return '';

                                                    const averageSalesFourAndTwentyFour = (assemblyExpanded.fourWeekSalesPerWeekWithRev + assemblyExpanded.twentyFourWeekSalesPerWeekWithRev) / 2;
                                                    let targetAssembledOnHand = parseNumberInputValue(assemblyExpanded.tgtAhead) * averageSalesFourAndTwentyFour < 2 ? 2 : parseNumberInputValue(assemblyExpanded.tgtAhead) * averageSalesFourAndTwentyFour;
                                                    let minAssembledOnHand = parseNumberInputValue(assemblyExpanded.minAhead) * averageSalesFourAndTwentyFour < 1 ? 1 : parseNumberInputValue(assemblyExpanded.minAhead) * averageSalesFourAndTwentyFour;
                                                    let avgAssembledOnHand = (minAssembledOnHand + targetAssembledOnHand) / 2;
                                                    let totalToPackage = 0;
                                                    
                                                    let materialsAvailable = "-";
                                                    if (assembly.currentlyPackaging) {
                                                        totalToPackage = assemblyExpanded.totalAssembledOnHandWithRev < targetAssembledOnHand ? targetAssembledOnHand - assemblyExpanded.totalAssembledOnHandWithRev : 0;
                                                        if (totalToPackage > 0) {
                                                            materialsAvailable = 'Yes';
                                                            assembly.partsToAssemblies.forEach((assemblyPart) => {
                                                                if (isImpliedPartRelation(assemblyPart)) return;
                                                                const expandedPart = this.state.parts.find(x => x.part.id === assemblyPart.partFk);
                                                                const totalNeededToPackage = Math.ceil(totalToPackage) * assemblyPart.quantity;
                                                                if (expandedPart.totalUnpackaged < totalNeededToPackage) {
                                                                    materialsAvailable = "No";
                                                                }
                                                            });
                                                            assembly.subAssembliesToAssemblies.forEach((subAssemblyToAssembly) => {
                                                                const totalNeededToPackage = Math.ceil(totalToPackage) * subAssemblyToAssembly.quantity;
                                                                const subAssemblyExpanded = this.state.subAssemblies.find(x => x.subAssembly.id === subAssemblyToAssembly.subAssemblyFk);
                                                                if (subAssemblyExpanded && subAssemblyExpanded.totalAssembledOnHand < totalNeededToPackage) {
                                                                    materialsAvailable = "No";
                                                                }
                                                            });
                                                        }
                                                    }

                                                    return (
                                                        <tr>
                                                            <td className="text-left">
                                                                {this.state.permissions.includes('EditAssembliesAndParts') ? (
                                                                    <div style={{cursor: 'pointer'}} onClick={(event) => this.editAssembly(assemblyExpanded, null, event.ctrlKey)}>
                                                                        <PartDisplay 
                                                                            part={{
                                                                                partId: assembly.assemblyId,
                                                                                revision: assembly.revision,
                                                                                description: assembly.description
                                                                            }}
                                                                            variant="table"
                                                                            classes={this.props.classes}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <PartDisplay 
                                                                        part={{
                                                                            partId: assembly.assemblyId,
                                                                            revision: assembly.revision,
                                                                            description: assembly.description
                                                                        }}
                                                                        variant="table"
                                                                        classes={this.props.classes}
                                                                    />
                                                                )}
                                                            </td>
                                                            <td>{totalToPackage === 0 ? '-' : totalToPackage.toFixed(0)}</td>
                                                            <td>{materialsAvailable}</td>
                                                            <td>{(assemblyExpanded.totalAssembledOnHandWithRev).toFixed(0)}</td>
                                                            <td>{minAssembledOnHand.toFixed(0)}</td>
                                                            <td>{targetAssembledOnHand.toFixed(0)}</td>
                                                            <td>{avgAssembledOnHand.toFixed(0)}</td>
                                                            <td>{assemblyExpanded.fourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                            <td>{assemblyExpanded.twentyFourWeekSalesPerWeekWithRev.toFixed(2)}</td>
                                                            <td><TextField value={assemblyExpanded.minAhead || ''} type="number"
                                                                           onChange={(event) => {
                                                                               assemblyExpanded.minAhead = parseNumberInputValue(event.target.value);
                                                                               this.setState({updated: new Date()});
                                                                           }} variant="outlined" style={{
                                                                width: 60,
                                                                margin: '0 auto',
                                                                display: 'block'
                                                            }}/></td>
                                                            <td><TextField value={assemblyExpanded.tgtAhead || ''} type="number"
                                                                           onChange={(event) => {
                                                                               assemblyExpanded.tgtAhead = parseNumberInputValue(event.target.value);
                                                                               this.setState({updated: new Date()});
                                                                           }} variant="outlined" style={{
                                                                width: 60,
                                                                margin: '0 auto',
                                                                display: 'block'
                                                            }}/></td>
                                                        </tr>
                                                    )
                                                })}
                                                </tbody>
                                            </table>
                                        </div>
                                        <center>
                                            <TablePagination
                                                rowsPerPageOptions={[50, 100, 200, 500]}
                                                colSpan={50}
                                                count={this.state.assembliesAndSubAssemblies.length}
                                                rowsPerPage={this.state.rowsPerPage}
                                                page={this.state.page}
                                                slotProps={{
                                                    select: {
                                                        'aria-label': 'rows per page',
                                                    },
                                                    actions: {
                                                        showFirstButton: true,
                                                        showLastButton: true,
                                                        slots: {
                                                            firstPageIcon: FirstPageIcon,
                                                            lastPageIcon: LastPageIcon,
                                                            nextPageIcon: ChevronRightIcon,
                                                            backPageIcon: ChevronLeftIcon,
                                                        },
                                                    },
                                                }}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </center>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </DashboardTemplate>
        );
    }
}

let globalProps;

Packaging.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Packaging);
